import { ChatComplianceBoxProps } from './chat-compliance-box';

export const chatComplianceBoxPropsLexi: ChatComplianceBoxProps = {
  headerText: 'Retningslinjer for anvendelse af Lexi',
  mainText: `Lexi skal anvendes af sagsbehandleren til at få adgang til vejledning, egne dokumenter og lovgivning, samt generel brug af AI sprogmodel model.

  Lexi må ikke anvendes til udarbejdelse af forvaltningsretlige afgørelser, til anbefaling eller udførelse af sagsskridt eller bruges til at foretage vurderinger.

  For uddybende information vedrørende dette, se vores politik på området på Kundeweb:`,
  link: {
    href: 'https://kundeweb.schultz.dk/h/b023bd8d-e89a-4018-a525-55a8aad79278/66ba23478b614de69e039730b7d671ae',
    label: 'Link til politik',
  },
};
